import { InfoIcon, LockIcon } from '@capsicum/common-web/icons';
import styled from 'styled-components';

export namespace S {
	export const Container = styled.section`
		display: flex;
		flex: 1;
		justify-content: center;
		align-items: center;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			text-align: center;
		}
	`;
	export const ContainerWrapper = styled.article`
		display: flex;
		flex: 1;
		justify-content: center;
		align-items: flex-start;
		max-width: 600px;
		padding: ${({ theme }) => theme.spacings.xlarge};
		gap: ${({ theme }) => theme.spacings.xlarge};
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			flex-direction: column;
			align-items: center;
			gap: ${({ theme }) => theme.spacings.medium};
			padding: ${({ theme }) => theme.spacings.medium};
		}
	`;
	export const CurrencyIconWrapper = styled.div`
		width: 110px;
		height: 110px;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			width: 36px;
			height: 36px;
		}
		& svg {
			width: 100%;
			height: 100%;
		}
		flex-shrink: 0;
	`;
	export const InfoContainer = styled.div`
		display: flex;
		flex-direction: column;
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			align-items: center;
		}
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
	export const InfoTitle = styled.div`
		${({ theme }) => theme.fonts.text.text4};
		margin-bottom: ${({ theme }) => theme.spacings.small};
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		word-break: break-word;
	`;
	export const InfoCurrency = styled.div`
		${({ theme }) => theme.fonts.headings.title1};
		margin-bottom: ${({ theme }) => theme.spacings.small};
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
		}
		word-break: break-word;

		/* Wide enough to usually prevent jumps when the balance can first be shown */
		min-width: 11ch;
	`;
	export const InfoAltCurrencyContainer = styled.div`
		display: flex;
		${({ theme }) => theme.fonts.text.text3};
		flex-wrap: wrap;
		gap: ${({ theme }) => theme.spacings.medium};
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			flex-direction: column;
			align-items: center;
		}
	`;
	export const InfoAltCurrency = styled.div`
		word-break: break-word;
	`;
	export const InfoLocked = styled.div`
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
	export const LockIconStyled = styled(LockIcon)`
		flex-shrink: 0;
	`;
	export const InfoIconStyled = styled(InfoIcon)`
		flex-shrink: 0;
	`;
}
